import { css } from '@emotion/css';
import { N50, N400, primaryBackground, lightGrey } from '@assets/colors';

export const styTableContainer = ({ withShadow, marginTop, maxContainerHeight }) => css`
  padding: 0;
  margin-top: ${marginTop || '24px'};
  ${withShadow && 'box-shadow: 0px 0 8px 0 rgba(0, 0, 0, 0.1);'};
  flex-grow: 1;
  max-height: ${maxContainerHeight};
`;

export const styTableHeaderRow = css`
  position: absolute;
  z-index: 1;
  width: 100%;
  background-color: ${N50};
`;

export const styTableHeaderCol = ({ align, hidden }) => css`
  background-color: ${N50};
  color: ${N400};
  font-size: 12px;
  border: none;
  font-weight: normal;
  padding: 4px 16px;
  height: 32px;
  vertical-align: middle;
  align-items: center;
  display: flex;
  ${align === 'right' && 'justify-content: flex-end; text-align: right;'}
  ${align === 'center' && 'justify-content: center; text-align: center;'}
  ${align === 'left' && 'text-align: left;'}
  ${hidden && 'display: none !important;'}
`;

export const styTableContentCol = ({ align, bold, color, hidden }) => css`
  padding: 0px 16px;
  display: flex !important;
  color: ${color} !important;
  margin-top: 0px !important;
  ${align === 'right' && 'justify-content: flex-end; text-align: right;'}
  ${align === 'center' && 'justify-content: center; text-align: center;'}
  ${align === 'left' && 'text-align: left;'}
  ${bold && 'font-weight: bold;'}
  ${hidden && 'display: none !important;'}
`;

export const styTableContentRow = ({ rowPadding, hover, isCursorPointer } = {}) => css`
  padding: ${rowPadding || '16px 0'};
  width: 100%;
  align-items: center;
  ${isCursorPointer && 'cursor: pointer;'}
  ${hover && `background: ${primaryBackground};`}
`;

export const styEmptyState = css`
  align-items: center;
  justify-content: center;
  padding-top: 32px;
  height: 200px;

  div:first-child {
    align-items: center;
    display: flex;
  }
`;

export const styCard = css`
  border: none;
  border-radius: 0px;
  cursor: pointer;
`;

export const styCardHeader = hover => css`
  border: none;
  background: none;
  padding: 0px;
  height: 48px;
  display: flex;
  align-items: center;
  ${hover && `background: ${primaryBackground};`}
`;

export const styCardHeaderRow = css`
  width: 100%;
  align-items: center;
`;

export const styDetail = css`
  padding: 24px;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;
  background-color: ${lightGrey};
  .item {
    margin-top: 16px;
  }
`;
export const styActionMenu = css`
  position: absolute;
  right: 16px;
  margin-top: -50px;
  z-index: 2;
`;

export const stySortIcon = css`
  width: 16px;
  height: 16px;
`;

export const styItemActionContainer = css`
  position: absolute;
  right: 16px;
  margin-top: -70px;
  z-index: 2;
`;

const commonTheadStyle = {
  borderBottomStyle: 'solid',
  borderBottomWidth: 2,
  borderBottomColor: N50,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  fontWeight: 'normal',
  padding: 16,
  background: 'inherit'
};

const commonColStyle = {
  borderBottomStyle: 'solid',
  borderBottomWidth: 2,
  borderBottomColor: N50,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  fontWeight: 'normal',
  paddingLeft: 16,
  paddingRight: 16,
};

const styles = {
  clickable: {
    cursor: 'pointer',
  },
  border: {
    borderBottom: 'rgba(51, 51, 51, 0.16)',
  },
  thead: {
    small: {
      ...commonTheadStyle,
    },
    tiny: {
      ...commonTheadStyle,
    },
  },
  col: {
    small: {
      fontSize: 13,
      ...commonColStyle,
    },
    tiny: {
      fontSize: 12,
      ...commonColStyle,
    },
  },
  caption: {
    display: 'table-caption',
  },
};

export default styles;
